import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store'
import { persistStore } from "redux-persist";
import { PersistGate } from 'redux-persist/integration/react';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
// import SentryRRWeb from "@sentry/rrweb";
import { BrowserTracing } from "@sentry/tracing";

import mixpanel from 'mixpanel-browser';

mixpanel.init('9129ac191f82f1672940c79cb3740933', {debug: true});

Sentry.init({
  dsn: "https://2a44b00cf9a34f20aec9077bc6fdbffc@sentry.dev.ywmobile.com/13",
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
      new Sentry.Replay(),
      new BrowserTracing({
        tracePropagationTargets: ["gongim.dev.cardelivery.co.kr", "gongim.cardelivery.co.kr", /^\//],
      }),
    // new Sentry.Replay({
    //   maskAllText: true,
    //   blockAllMedia: true,
    // })
    // new SentryRRWeb({ errorsOnly: true }),
  ],
  tracesSampleRate: 1.0,
  enabled: window.location.host !== 'localhost:3001',
  environment: (window.location.host === 'localhost:3001' || window.location.host === 'gongim.dev.cardelivery.co.kr') ? "development" : "production",
});


const persister = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persister}>
      <App />
    </PersistGate>
  </Provider>
  // <React.StrictMode>
  // </React.StrictMode>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
